import { BrowserRouter as Router } from 'react-router-dom';
import { PhysicsProvider } from './components/PaintPhysics';
import { AnimatedRoutes } from './components/PageTransition';
import { useEffect } from 'react';
import { isPasswordRecoveryCallbackUrl, markPasswordRecoveryActive, isPasswordRecoveryUrl } from './lib/authRecovery';
import InstallAppPrompt from './components/InstallAppPrompt';
import AppErrorBoundary from './components/AppErrorBoundary';

function App() {
  // Global sniffer: Catch recovery hashes on ANY page before React Router strips them.
  // This is a failsafe for when Supabase falls back to the base Site URL.
  useEffect(() => {
    if (isPasswordRecoveryUrl()) {
      markPasswordRecoveryActive({ refreshWindow: isPasswordRecoveryCallbackUrl() });
    }
  }, []);

  useEffect(() => {
    const root = document.documentElement;
    const standaloneQuery = window.matchMedia?.('(display-mode: standalone)');

    const syncInstalledMode = () => {
      const installed = Boolean(standaloneQuery?.matches || window.navigator.standalone === true);
      const touchDevice = (navigator.maxTouchPoints || 0) > 0;
      const appSized = window.innerWidth <= 1180 || touchDevice;

      root.classList.toggle('linkit-installed-app', installed);
      root.classList.toggle('linkit-installed-mobile', installed && appSized);
    };

    syncInstalledMode();
    standaloneQuery?.addEventListener?.('change', syncInstalledMode);
    window.addEventListener('resize', syncInstalledMode);
    window.addEventListener('orientationchange', syncInstalledMode);

    return () => {
      standaloneQuery?.removeEventListener?.('change', syncInstalledMode);
      window.removeEventListener('resize', syncInstalledMode);
      window.removeEventListener('orientationchange', syncInstalledMode);
      root.classList.remove('linkit-installed-app', 'linkit-installed-mobile');
    };
  }, []);

  return (
    <PhysicsProvider>
      <Router>
        <AppErrorBoundary>
          <AnimatedRoutes />
        </AppErrorBoundary>
        <InstallAppPrompt />
      </Router>
    </PhysicsProvider>
  );
}

export default App;
